import { appInfo } from "./appInfo.const";

export const apiUrls = {

    // public routes
    locations: `${appInfo.locationUrl}`,
    login: `${appInfo.authUrl}/login`,
    refresh: `${appInfo.authUrl}/refresh`,
    register: `${appInfo.authUrl}/register`,
    categorization: `${appInfo.baseUrl}/categorization`,
    serviceProviders: `${appInfo.baseUrl}/service-providers`,
    serviceItems: `${appInfo.baseUrl}/service-items`,
    serviceItemDetails: (id: string) => `${appInfo.baseUrl}/service-items/${id}`,
    faq: `${appInfo.baseUrl}/faq`,
    termsConditions: `${appInfo.baseUrl}/terms-conditions`,
    agreement: `${appInfo.baseUrl}/agreement`,
    privacyPolicy: `${appInfo.baseUrl}/privacy-policy`,
    query: `${appInfo.baseUrl}/query`,
    aboutUs: `${appInfo.baseUrl}/about-us`,
    checkBusinessName: `${appInfo.baseUrl}/check-business-name`,
    checkBusinessUser: `${appInfo.baseUrl}/check-business-user`,

    // auth routes
    user: `${appInfo.authUrl}/user`,
    updateAccount: `${appInfo.authUrl}/update-account`,
    logout: `${appInfo.authUrl}/logout`,
    profile: `${appInfo.authUrl}/profile`,
    updateProfile: `${appInfo.authUrl}/update-profile`,
    updatePhoto: `${appInfo.authUrl}/update-photo`,

    // business routes
    getBusinesses: `${appInfo.baseUrl}/business-by-user`,
    storeBusiness: `${appInfo.baseUrl}/create-business`,
    getBusinessByCode: `${appInfo.baseUrl}/business-by-code`,
    getBusinessDetails: `${appInfo.baseUrl}/business-details`,
    createBusiness: `${appInfo.baseUrl}/update-business`,
    updateBusiness: `${appInfo.baseUrl}/update-business`,
    // business categorization
    getBusinessCategorization: `${appInfo.baseUrl}/biz-categorization`,
    updateBusinessCategorization: `${appInfo.baseUrl}/update-biz-categorization`,
    categoryList: "/categories",
    subcategoryList: "/subcategories",
    // business items
    items: `${appInfo.baseUrl}/items`,
    groupedItems: `${appInfo.baseUrl}/grouped-items`,
    createItem: `${appInfo.baseUrl}/create-item`,
    getItem: `${appInfo.baseUrl}/get-item`,
    updateItem: `${appInfo.baseUrl}/update-item`,
    deleteItemImage: `${appInfo.baseUrl}/delete-item-image`,
    setDefaultItemImage: `${appInfo.baseUrl}/set-default-item-image`,

    // bookings
    getBookingList: `${appInfo.baseUrl}/booking-list`,
    getBookingDetails: `${appInfo.baseUrl}/booking-details`,
    createBooking: `${appInfo.baseUrl}/create-booking`,

    // order
    createOrder: `${appInfo.baseUrl}/create-order`,
    createOrderFromBooking: `${appInfo.baseUrl}/create-order-from-booking`,
    getOrderList: `${appInfo.baseUrl}/order-list`,

    // dashboard routes
    // dashboard: (code: string) => `${appInfo.baseUrl}/dashboard/${code}`,
    // businessInfo: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-info`,
    // updateBusinessInfo: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-info/update`,
    // businessSettings: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-settings`,
    // updateBusinessSettings: (code: string) => `${appInfo.baseUrl}/dashboard/${code}/business-settings/update`
};
